import { GetGeoAreaRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'configs';
import { useParticipantsGeoAreaApi } from 'services';

export const useGetGeoArea = (request: GetGeoAreaRequest) => {
  const { getGeoArea } = useParticipantsGeoAreaApi();

  return useQuery({
    queryKey: [queryKeys.getGeoArea, { request }],
    queryFn: () => getGeoArea(request),
    enabled: !!request.geoAreaId,
    staleTime: Infinity
  });
};
